import * as React from 'react';
import { withRouteData } from 'react-static';

import AboutPageComponent from '../../components/AboutPage/AboutPage';
import { AboutPageLocale } from '../../components/AboutPage/aboutPage.locale';

interface AboutPageProps {
  locale: AboutPageLocale;
}

const AboutPage: React.SFC<AboutPageProps> = ({ locale }) => <AboutPageComponent locale={locale} />;

export default withRouteData(AboutPage);



// WEBPACK FOOTER //
// /www/client/src/containers/AboutPage/AboutPage.tsx